import NextLink from "next/link";
import React from "react";

const Link = React.forwardRef<
  HTMLAnchorElement,
  React.ComponentProps<typeof NextLink>
>(({ children, ...props }, ref) => {
  return (
    <NextLink ref={ref} {...props} prefetch={props.prefetch ?? false}>
      {children}
    </NextLink>
  );
});

export default Link;
